export const USER_DATA                  = "USER_DATA";
export const INIT_LOGOUT                = "INIT_LOGOUT";

// Create Form
export const FORM_META_DATA             = "FORM_META_DATA";
export const ADD_FIELD_DATA             = "ADD_FIELD_DATA";
export const EDIT_FIELD_DATA            = "EDIT_FIELD_DATA";
export const DELETE_FIELD_DATA          = "DELETE_FIELD_DATA";
export const REARRANGE_FIELD_DATA       = "REARRANGE_FIELD_DATA";

export const CREATE_WORKFLOW_ACTION     = "CREATE_WORKFLOW_ACTION";
export const EDIT_WORKFLOW_ACTION       = "EDIT_WORKFLOW_ACTION";
export const DELETE_WORKFLOW_ACTION     = "DELETE_WORKFLOW_ACTION";

export const SERVICE_CARD_DATA          = "SERVICE_CARD_DATA";
export const CREATE_SERVICE_CARD        = "CREATE_SERVICE_CARD";
export const EDIT_SERVICE_CARD          = "EDIT_SERVICE_CARD";
export const REARRANGE_SERVICE_CARD     = "REARRANGE_SERVICE_CARD";
export const DELETE_SERVICE_CARD        = "DELETE_SERVICE_CARD";

export const CATEGORY_DATA              = "CATEGORY_DATA";
export const CREATE_CATEGORY            = "CREATE_CATEGORY";
export const EDIT_CATEGORY              = "EDIT_CATEGORY";
export const DELETE_CATEGORY            = "DELETE_CATEGORY";